module.exports = __webpack_public_path__ + "img/mdi_user-off-outline.803aec05.svg";